"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FuelSelector = exports.fuelOptionLabel = exports.fuelSelectStyle = exports.getFuelOptions = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const theme_1 = require("../../theme");
const intensity_low_png_1 = __importDefault(require("../../../images/intensity-low.png"));
const intensity_medium_png_1 = __importDefault(require("../../../images/intensity-medium.png"));
const intensity_high_png_1 = __importDefault(require("../../../images/intensity-high.png"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_select_1 = __importDefault(require("react-select"));
const common_styled_components_1 = require("../common-styled-components");
const carbonIntensity_1 = require("../../util/carbonIntensity");
const calculator_types_1 = require("../fleet-calculator/calculator-types");
const NumberInput_1 = require("../generic/NumberInput");
const getFuelOptions = (fuels, isComparison) => {
    return (Object.keys(fuels)
        .map((key) => ({
        value: key,
        label: fuels[key].name,
        intensityText: fuels[key].intensity_text ??
            (0, carbonIntensity_1.getCarbonIntensity)(fuels[key].average_intensity),
    }))
        // .filter((option) =>
        //   isComparison
        //     ? option.intensityText !== "high" || option.value === "8"
        //     : fuels[option.value].is_source_fuel
        // )
        .sort((f1, f2) => f1.label.localeCompare(f2.label)));
};
exports.getFuelOptions = getFuelOptions;
exports.fuelSelectStyle = {
    control: (baseStyles, _state) => ({
        ...baseStyles,
        borderColor: theme_1.theme.colors.grey(3),
    }),
};
const IntensityImage = styled_components_1.default.img `
  height: 32px;
  width: 32px;
  margin-right: ${theme_1.theme.spacing(2)};
`;
const energyIcon = (intensityText) => {
    switch (intensityText) {
        case "low":
            return (0, jsx_runtime_1.jsx)(IntensityImage, { src: intensity_low_png_1.default, width: 32 });
        case "medium":
            return (0, jsx_runtime_1.jsx)(IntensityImage, { src: intensity_medium_png_1.default, width: 32 });
        case "high":
            return (0, jsx_runtime_1.jsx)(IntensityImage, { src: intensity_high_png_1.default, width: 32 });
    }
};
const OptionContent = styled_components_1.default.div `
  display: flex;
  align-items: center;
  height: 32px;
`;
const fuelOptionLabel = ({ label, intensityText, }) => ((0, jsx_runtime_1.jsxs)(OptionContent, { children: [energyIcon(intensityText), (0, jsx_runtime_1.jsx)("div", { children: label })] }));
exports.fuelOptionLabel = fuelOptionLabel;
const FuelSelector = ({ isComparison, texts, metadata, onChangeFuelType, params, editable, setParamsHelper, }) => {
    const fuelOptions = (0, exports.getFuelOptions)(metadata.fuels, isComparison); // allow all
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)(common_styled_components_1.Selector, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SelectorLabel, { children: isComparison ? texts.fuel_type_for_comparison : texts.fuel_type }), (0, jsx_runtime_1.jsx)(react_select_1.default, { options: fuelOptions, onChange: (newValue) => onChangeFuelType(newValue?.value || "1", metadata), value: params.fuel_type !== undefined
                            ? fuelOptions.find((f) => f.value === params.fuel_type.toString())
                            : undefined, isOptionSelected: (option) => params.fuel_type !== undefined
                            ? option.value === params.fuel_type.toString()
                            : false, styles: exports.fuelSelectStyle, formatOptionLabel: exports.fuelOptionLabel }), params.fuel_type !== undefined && ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)("p", { style: {
                                marginTop: theme_1.theme.spacing(0),
                                marginBottom: 0,
                            }, children: ["LCV:", " ", metadata.fuels[params.fuel_type.toString()].energy_content.toLocaleString("en-US", {
                                    maximumFractionDigits: 3,
                                }), " ", "MJ/g"] }) }))] }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.Selector, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SelectorLabel, { children: texts.price_per_ton }), (0, jsx_runtime_1.jsx)(NumberInput_1.NumberInput, { value: params.fuel_price, onChange: (value) => setParamsHelper({ fuel_price: value }) })] }), isComparison && (0, calculator_types_1.isAlternativeFuelParams)(params) && ((0, jsx_runtime_1.jsxs)(common_styled_components_1.Selector, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SelectorLabel, { disabled: !editable, children: "Engine change cost (USD)" }), (0, jsx_runtime_1.jsx)(NumberInput_1.NumberInput, { disabled: !editable, value: params.engine_change_cost, onChange: (value) => setParamsHelper({ engine_change_cost: value }) })] }))] }));
};
exports.FuelSelector = FuelSelector;
